/**
 * AI Prompt kategorileri
 */
export enum AIPromptCategory {
    ImageGeneration = 'ImageGeneration',
    TextGeneration = 'TextGeneration',
    Custom = 'Custom'
}

/**
 * AI Model tipleri
 */
export enum AIModelType {
    EachLabs = 'EachLabs',
    GoogleGemini = 'GoogleGemini',
    AzureOpenAI = 'AzureOpenAI',
    GoogleGeminiFlash = 'GoogleGeminiFlash',
    GoogleGeminiNanoBanana21 = 'GoogleGeminiNanoBanana21',
    GoogleGeminiNanoBanana21Lcw = 'GoogleGeminiNanoBanana21Lcw',
    AIGate = 'AIGate',
    GoogleGeminiProLcw = 'GoogleGeminiProLcw',
    AIGateProLcw = 'AIGateProLcw'
}

/**
 * AI Prompt Category dropdown options
 */
export const AIPromptCategoryOptions = [
    { value: AIPromptCategory.ImageGeneration, label: 'aiPrompt.categories.imageGeneration' },
    { value: AIPromptCategory.TextGeneration, label: 'aiPrompt.categories.textGeneration' },
    { value: AIPromptCategory.Custom, label: 'aiPrompt.categories.custom' }
];

/**
 * AI Model Type dropdown options
 */
export const AIModelTypeOptions = [
    { value: AIModelType.EachLabs, label: 'aiPrompt.modelTypes.eachLabs' },
    { value: AIModelType.GoogleGemini, label: 'aiPrompt.modelTypes.googleGemini' },
    { value: AIModelType.GoogleGeminiFlash, label: 'aiPrompt.modelTypes.googleGeminiFlash' },
    { value: AIModelType.GoogleGeminiNanoBanana21, label: 'aiPrompt.modelTypes.googleGeminiNanoBanana21' },
    { value: AIModelType.GoogleGeminiNanoBanana21Lcw, label: 'aiPrompt.modelTypes.googleGeminiNanoBanana21Lcw' },
    { value: AIModelType.AzureOpenAI, label: 'aiPrompt.modelTypes.azureOpenAI' },
    { value: AIModelType.AIGate, label: 'aiPrompt.modelTypes.aiGate' },
    { value: AIModelType.GoogleGeminiProLcw, label: 'aiPrompt.modelTypes.googleGeminiProLcw' },
    { value: AIModelType.AIGateProLcw, label: 'aiPrompt.modelTypes.aiGateProLcw' }
];

